import { Account, Client, ID } from "appwrite";

export const appwrite = new Client();
appwrite.setEndpoint(process.env.REACT_APP_APPWRITE_ENDPOINT); // Your Appwrite Endpoint
appwrite.setProject(process.env.REACT_APP_APPWRITE_PROJECTID);
// console.log("start");

export const account = new Account(appwrite);

